import React from 'react'
import Button from '../../../assets/Button'

const Save = () => {

  return (
    <div>
    <Button text={'Saved'}/>
    </div>
  );
}

export default Save;
